import { render, staticRenderFns } from "./dataManage.vue?vue&type=template&id=631dc4a2&"
import script from "./dataManage.vue?vue&type=script&lang=js&"
export * from "./dataManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('631dc4a2')) {
      api.createRecord('631dc4a2', component.options)
    } else {
      api.reload('631dc4a2', component.options)
    }
    module.hot.accept("./dataManage.vue?vue&type=template&id=631dc4a2&", function () {
      api.rerender('631dc4a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/onlineshop/dataManage.vue"
export default component.exports